import { Alert } from '@mui/material'
import type { ReactNode } from 'react'
import { toast } from 'react-toastify'
import IcBaselineError from '~icons/ic/baseline-error'
import { UIDialog } from 'src/components/ui/Modal'

export const opAction = async (cb: () => any, detail: ReactNode) => {
  const toProceed = await UIDialog.confirm({
    heading: (
      <div className="font-semibold text-red-500">Are you sure about this?</div>
    ),
    content: (
      <div>
        <Alert
          color="error"
          icon={<IcBaselineError className="size-6" />}
          className="text-sm"
        >
          This operation is possible only because you are a designated admin.
          Proceeding with this operation is{' '}
          <strong>permanent and cannot be undone</strong>. Please proceed with
          caution.
        </Alert>
        {detail}
      </div>
    ),
    confirmProps: {
      color: 'danger',
    },
  })
  if (!toProceed) return

  try {
    await cb()
    toast.success('success')
  } catch (err: any) {
    toast.error(err?.message)
  }
}
